import "../styles/ThemeToggle.css";

function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === "dark";

  return (
    <button
      aria-label={isDark ? "Включить светлую тему" : "Включить темную тему"}
      className="theme-toggle"
      onClick={onToggle}
      title={isDark ? "Светлая тема" : "Темная тема"}
      type="button"
    >
      <span aria-hidden="true">{isDark ? "☀️" : "🌙"}</span>
    </button>
  );
}

export default ThemeToggle;
